import axios from "axios";

const http = axios.create({

  baseURL : process.env.REACT_APP_API_URL,
  headers: {
    "Content-type": "application/json"
  }
});
axios.interceptors.request.use(request => {

  // Edit request config
  return request;
}, error => {
  console.log(error);
  return Promise.reject(error);
});

export default {
  auth(url = 'users') {
    return {
      login: ({ email, password }) => http.post(url + '/authenticate', {
        username: email,
        password: password
      })
     
    }
  },

  map(url = 'map') {
    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/list', config),
      fetchPagination: (page, limit, name, category) =>
        http.get(url + "?page=" + page + "&limit=" + limit + "&name=" + name + "&category=" + category, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url, newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/" + id, updatedRecord, config),
      delete: id => http.delete(url + "/" + id, config)
    }
  },

  user(url = 'users') {

    const config = {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      getCart: (param) => http.post(url + '/getCart',param, config),
      fetchPagination: (page, limit = 10, firstName = null, email = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&firstName=" + firstName + "&email=" + email, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/register', newRecord, config),
      update: (id, updatedRecord) => http.post(url + "/update/" + id, updatedRecord, config),
      updateCart: (id, updatedRecord) => http.post(url + "/updateCart/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      sendOtp: (param) => http.post(url + '/otp/send',param),
      verifyOtp: (param) => http.post(url + '/otp/verify',param),
      register: (param) => http.post(url + '/register', param)
    }
  },

  feedback(url = 'feedbacks') {

    const config = {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, firstName = null, email = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&firstName=" + firstName + "&email=" + email, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.post(url + "/update/" + id, updatedRecord, config),
      updateCart: (id, updatedRecord) => http.post(url + "/updateCart/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      getByServiceId: id => http.get(url + "/getByServiceId/" + id, config),
    }
  },
  result(url = 'results') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, title = null, description = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&title=" + title + "&description=" + description, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.post(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config)
    }
  },
  blog(url = 'blogs') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, name = null, type) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&name=" + name, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      getByTitle: id => http.get(url + "/getByTitle/" + id, config),
    }
  },
  booking(url = 'bookings') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, name = null, type) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&name=" + name, config),
      fetchById: id => http.get(url + "/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config)
    }
  },
  category(url = 'category') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, title = null, description = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&title=" + title + "&description=" + description, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.post(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config)
    }
  },

  doctor(url = 'doctors') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, name=null, email = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit+ "&name=" + name + "&email=" + email, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      getByTitle: id => http.get(url + "/getByTitle/" + id, config),
    }
  },

  service(url = 'services') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/getallproducts', config),
      getFilteredAllServices: (param) => http.post(url + '/getFilteredAllServices',param, config),
      getFeatured: (param) => http.post(url + '/getFeatured',param, config),
      fetchAllPackages: () => http.get(url + '/getAllPackages', config),
      fetchRandomPackages: (param) => http.post(url + '/getRandomPackages',param, config),
      fetchPagination: (page = 1, limit = 10,title,price) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit+ "&title=" + title + "&price=" + price + "&type=" + "product", config),
      fetchPagfetchPackagesPaginationination: (page = 1, limit = 10,title,price) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit+ "&title=" + title + "&price=" + price + "&type=" + "package", config),
    
        fetchById: id => http.get(url + "/single/" + id, config),
        getByTitle: id => http.get(url + "/getByTitle/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      filtered: (param) => http.post(url + '/filtered',param, config),
    }
  },

  promocode(url = 'promo_codes') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, promoCode = null, description = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&promoCode=" + promoCode + "&description=" + description, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      getbypromocode: param => http.post(url + '/getbypromocode', param, config),
    }
  },

  coupon(url = 'coupons') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      getFeatured: (param) => http.post(url + '/getFeatured',param, config),
      fetchPagination: (page, limit = 10, title = null, description = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&title=" + title + "&description=" + description, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config)
    }
  },

  doctorbooking(url = 'doctorbookings') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      getFeatured: (param) => http.post(url + '/getFeatured',param, config),
      fetchPagination: (page, limit = 10, title = null, description = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&title=" + title + "&description=" + description, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      getMyBookings: param => http.post(url + '/getFeatured', param, config),
      getAvailableTimeSlots: param => http.post(url + '/getAvailableTimeSlots', param, config),
    }
  },

  event(url = 'events') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, title = null, description = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&title=" + title + "&description=" + description, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
     
    }
  },
  contact(url = 'contacts') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, title = null, description = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&title=" + title + "&description=" + description, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
     
    }
  },
  order(url = 'order') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, transaction_no = null, customer_name = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&transaction_no=" + transaction_no + "&customer_name=" + customer_name, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.post(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      getMyOrders: id => http.get(url + '/getMyOrders/'+ id, config),
      getAvailableTimeSlots: param => http.post(url + '/getAvailableTimeSlots', param, config),
    }
  },
  review(url = 'reviews') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, rating = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&rating=" + rating, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config)
    }
  },
  offer(url = 'offers') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchTopSlider: () => http.get(url + '/getTopSliders', config),
      fetchBottomSlider: () => http.get(url + '/getBottomSliders', config),
      fetchPagination: (page, limit = 10, rating = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&rating=" + rating, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config)
    }
  },
  giftcard(url = 'giftcards') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchTopSlider: () => http.get(url + '/getTopSliders', config),
      fetchBottomSlider: () => http.get(url + '/getBottomSliders', config),
      fetchPagination: (page, limit = 10, rating = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&rating=" + rating, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config)
    }
  },

  giftcardorder(url = 'giftcardorders') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchTopSlider: () => http.get(url + '/getTopSliders', config),
      fetchBottomSlider: () => http.get(url + '/getBottomSliders', config),
      fetchPagination: (page, limit = 10, rating = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&rating=" + rating, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config)
    }
  },

  notification(url = 'notification') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, title = null, description = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&title=" + title + "&description=" + description, config),
      getMyNotifications: id => http.get(url + "/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.post(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      getMyNotifications: id => http.get(url + "/getMyNotifications/" + id, config),
    }
  },
  branche(url = 'branches') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, name = null, email = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&name=" + name + "&email=" + email, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config)
    }
  },
  department(url = 'departments') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, title = null, description = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&title=" + title + "&description=" + description, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.post(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      getByTitle: id => http.get(url + "/getByTitle/" + id, config),
    }
  },
  utility(url = 'utility') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      upload: (file) => http.post(url + '/upload',file, config),
      createPaymentIntent: (param) => http.post(url + '/createPaymentIntent',param, config),
    }
  },

}